import React, { useEffect, useState } from 'react'

import {
  Button,
  Row,
} from 'components'
import { SPACING } from 'utils'
import {
  useModal,
  useLoading,
  useException,
} from 'hooks'
import { DashboardServices, IPizzaReportResponse, IBarReportResponse } from 'services/GST/Dashboard'
import { IResponseTypes } from 'services/core/genericEntityGST'

import { useDashboard } from '../../context'
import PieView from './components/PieView'
import LinearView from './components/LinearView'

const ReportView: React.FC = () => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { getException, createCustomException } = useException()
  const {
    reportType,
    setViewGraphic,
    selectedItensOfGrid,
    unidadeGestoraId,
    periodo,
    contentReportType,
  } = useDashboard()

  const [pizzaGraphicData, setPizzaGraphicData] = useState<IPizzaReportResponse>()
  const [barGraphicData, setBarGraphicData] = useState<IBarReportResponse[]>()

  const getPizzaGraphicData = () => {
    setLoading('loading')

    DashboardServices()
      .getPizzaGraphicData({
        tipoDashboard: contentReportType,
        periodoInicio: periodo.inicio,
        periodoFim: periodo.fim,
        idContrapartes: selectedItensOfGrid.idContraparte,
        idContraparteSubstitutos: selectedItensOfGrid.idContraparteSubstituto,
        idEmpresas: selectedItensOfGrid.idEmpresa,
        idCentroPlantas: selectedItensOfGrid.idCentroPlanta,
        idFornecedors: selectedItensOfGrid.idFornecedor,
        idUnidadeGestora: unidadeGestoraId,
      })
      .then(response => {
        if (response.status !== 200 || response.data.tipo === IResponseTypes['alert']) {
          const { tipo, detalhe, mensagem } = response.data

          showModal({
            type: 'alert',
            message: mensagem,
            hideButtonCancel: true,
            txtButtonConfirm: 'OK',
            handleConfirm: () => setViewGraphic(prevState => !prevState)
          })
          return
        }

        setPizzaGraphicData(response.data.entity)
      })
      .catch((err: Error) => {
        const error = getException(err)

        showModal({
          type: error.tipo || 'error',
          message: error.mensagem,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
      .finally(() => setLoading('idle'))
  }

  const getBarGraphicData = () => {
    setLoading('loading')

    DashboardServices()
      .getBarGraphicData({
        tipoDashboard: contentReportType,
        periodoInicio: periodo.inicio,
        periodoFim: periodo.fim,
        idContrapartes: selectedItensOfGrid.idContraparte,
        idContraparteSubstitutos: selectedItensOfGrid.idContraparteSubstituto,
        idEmpresas: selectedItensOfGrid.idEmpresa,
        idCentroPlantas: selectedItensOfGrid.idCentroPlanta,
        idFornecedors: selectedItensOfGrid.idFornecedor,
        idUnidadeGestora: unidadeGestoraId,
      })
      .then(response => {
        if (response.status !== 200 || response.data.tipo === IResponseTypes['alert']) {
          const { tipo, detalhe, mensagem } = response.data

          showModal({
            type: 'alert',
            message: mensagem,
            hideButtonCancel: true,
            txtButtonConfirm: 'OK',
            handleConfirm: () => setViewGraphic(prevState => !prevState)
          })

          return
        }

        setBarGraphicData(response.data.entity)
      })
      .catch((err: Error) => {
        const error = getException(err)

        showModal({
          type: error.tipo || 'error',
          message: error.mensagem,
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
      .finally(() => setLoading('idle'))
  }

  useEffect(() => {
    const getGraphic = {
      circular: getPizzaGraphicData,
      linear: getBarGraphicData,
    }

    getGraphic[reportType]()
  }, [])

  return (
    <>
      {
        reportType === 'circular' && (
          <PieView
            data={pizzaGraphicData}
          />
        )
      }
      {
        reportType === 'linear' && (
          <LinearView
            data={barGraphicData}
          />
        )
      }
      <Row justifyContent="flex-end">
        <Button
          text="VOLTAR"
          onClick={() => setViewGraphic(prevState => !prevState)}
          marginTop={SPACING.spacing10}
        />
      </Row>
    </>
  )
}

export default ReportView
